import { basename } from "./constant";

export const saveSession = (data) => {
  localStorage.setItem("authToken", data.token);
  localStorage.setItem("id", data.id);
  localStorage.setItem("email", data.email);
  localStorage.setItem("userType", data.user_type);
  localStorage.setItem("code", data.code);
};

export const getSession = () => {
  return {
    authToken: localStorage.getItem("authToken"),
    id: localStorage.getItem("id"),
    email: localStorage.getItem("email"),
    userType: localStorage.getItem("userType"),
    code: localStorage.getItem("code"),
  };
};



export const pathApp = window.location.pathname.slice(0, 12) == "/app-testing" ? "/" : '/app/'
export const pathTesting = '/app-testing'

// console.log('pathApp',pathApp);


export const clearSession = () => {
  localStorage.clear();
};
export const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const liveStripURL = "https://buy.stripe.com/cN2dSQb3D8JTe4gdR3";
export const liveStripFreeURL = "https://buy.stripe.com/3csbKIdbLgclf8k6or";

//--------------------------- DemoURL's-------------------------
export const DemoStripeURL = "https://buy.stripe.com/test_14kg2FfcHeFn9rO6ov";
export const DemoStripFreeURL =
  "https://buy.stripe.com/test_dR617Ld4z7cV6fC4gl";

// export const DemoStripeURL = "https://buy.stripe.com/test_fZecQt3tZ9l31ZmfYY";
// export const DemoStripFreeURL =
//   "https://buy.stripe.com/test_dR617Ld4z7cV6fC4gl";

export const influncer_trail_stripe = "https://buy.stripe.com/test_14kg2FfcHeFn9rO6ov";
export const influncer_after_trail_stripe =
  "https://buy.stripe.com/test_00geYBaWr8gZ1Zm28g";


export const Demo_influncer_trail = "https://buy.stripe.com/test_14kg2FfcHeFn9rO6ov";
export const Demo_influncer_after_trail = "https://buy.stripe.com/test_00geYBaWr8gZ1Zm28g"

export const influncer_trail_live = 'https://buy.stripe.com/dR6g0Y8Vv9NX6BObIU'
export const influncer_after_trail_live = 'https://buy.stripe.com/3csbKIdbLgclf8k6or'

export let URLCheck = window.location.pathname.slice(0, 12) !== '/app-testing' ? '/' : pathTesting



export let stripURL = window.location.pathname.slice(0, 12) === '/app-testing' ? DemoStripeURL : liveStripURL
export let stripURLFree = window.location.pathname.slice(0, 12) === '/app-testing' ? DemoStripFreeURL : liveStripFreeURL

export let stripInfluncerURL = window.location.pathname.slice(0, 12) === '/app-testing' ? Demo_influncer_trail : influncer_trail_live

export let stripInfluncerURLFree = window.location.pathname.slice(0, 12) === '/app-testing' ? Demo_influncer_after_trail : influncer_after_trail_live

export const basenameURL = window.location.pathname.slice(0, 12) === '/app-testing' ?
  'https://affirmate.life/affirmation_backend/api/user/' :
  'https://affirmate.life/affirmation_backend/api/user/'




// export let liveStr = 'https://buy.stripe.com/3csbKIdbLgclf8k6or'

// export let liveStr = 'https://buy.stripe.com/8wM2a87Rrgclgco9AS'
export let liveStr = 'https://buy.stripe.com/7sI4ig2x73pz3pC9AV'